import type { SVGProps } from "react";

const SvgHypoNoeSmallLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="41 41 430 430"
    fill="none"
    {...props}
  >
    <path
      fill="#0066BA"
      fillRule="evenodd"
      d="M41 41h429.999v429.999H41z"
      clipRule="evenodd"
    />
    <path
      fill="#003063"
      fillRule="evenodd"
      d="M433.426 202.251c-42.232.051-108.728 11.979-170.003 68.953-66.138 61.634-132.839 74.227-176.863 74.227h-.358c-20.886 0-36.653-2.918-45.201-4.966v130.536H471V205.322a224.4 224.4 0 0 0-37.523-3.122"
      clipRule="evenodd"
    />
    <path
      fill="#FCD400"
      fillRule="evenodd"
      d="M41 41v429.999h429.999V41zm392.426 161.25c-42.232.051-108.729 11.978-170.004 69.004-66.138 61.531-132.839 74.227-176.862 74.227H86.2c-20.886 0-36.652-2.969-45.201-5.017v130.535h429.999V205.321a224.3 224.3 0 0 0-37.522-3.122zM52.057 314.408c8.037 1.536 19.76 3.071 34.144 3.071 40.287-.102 101.357-12.695 163.912-70.796a264.2 264.2 0 0 1 183.262-72.076c16.483 0 29.485 1.536 37.573 2.867V41H41v270.797l1.945.512c2.048.512 5.12 1.28 9.112 2.048z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgHypoNoeSmallLogo;
